import { ExternalLink } from "lucide-react";
import { usePoll } from "@/context/AuthContext";

const tone = { Bullish: "text-[#00FF66] border-[#00FF66]/30", Bearish: "text-[#FF3366] border-[#FF3366]/30", Neutral: "text-gray-400 border-white/10" };
const ago = (iso) => {
  if (!iso) return "";
  const m = Math.round((Date.now() - new Date(iso)) / 60000);
  return m < 60 ? `${m}m ago` : m < 1440 ? `${Math.round(m / 60)}h ago` : `${Math.round(m / 1440)}d ago`;
};

export default function NewsList({ limit = 50, compact }) {
  const { data, error } = usePoll("/news", 60000);
  if (error) return <div className="text-sm text-[#FF3366]">{error}</div>;
  if (!data) return <div className="space-y-3">{Array.from({ length: 4 }).map((_, i) => <div key={i} className="h-12 rounded-lg bg-white/5 animate-pulse" />)}</div>;
  if (!data.items.length) return <div className="text-sm text-gray-500">News feeds are unreachable right now.</div>;
  return (
    <ul className="divide-y divide-white/5" data-testid="news-list">
      {data.items.slice(0, limit).map((n, i) => (
        <li key={n.link + i} className="py-3" data-testid={`news-item-${i}`}>
          <a href={n.link} target="_blank" rel="noreferrer" className="group flex gap-3">
            <div className="flex-1 min-w-0">
              <div className={`text-sm group-hover:text-[#00FF66] transition-colors ${compact ? "line-clamp-2" : ""}`}>{n.title}</div>
              <div className="flex items-center gap-2 mt-1 text-[11px] text-gray-500">
                <span>{n.source}</span><span>·</span><span>{ago(n.published)}</span>
                <span className={`border rounded px-1.5 ${tone[n.impact]}`}>{n.impact}</span>
              </div>
            </div>
            {!compact && <ExternalLink size={14} className="text-gray-600 shrink-0 mt-1" />}
          </a>
        </li>
      ))}
    </ul>
  );
}
